import React from "react";
import { TIER_STYLES, REGISTRY_STYLES } from "@/lib/api";
import { ShieldCheck, ShieldQuestion, ShieldAlert, ShieldX, BadgeCheck, CircleHelp } from "lucide-react";

const TIER_ICON = {
  reviewed: BadgeCheck,
  confirmed: ShieldCheck,
  high: ShieldCheck,
  review: ShieldQuestion,
  candidate: CircleHelp,
  rejected: ShieldX,
};

export function ConfidenceBadge({ info, tier, className = "" }) {
  const t = tier || info?.tier;
  if (!t) return null;
  const Icon = TIER_ICON[t] || ShieldAlert;
  const style = TIER_STYLES[t] || "bg-slate-800 text-slate-300 border-slate-700";
  return (
    <span
      data-testid={`confidence-badge-${t}`}
      className={`inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-mono font-semibold ${style} ${className}`}
      title={info?.status}
    >
      <Icon className="w-3.5 h-3.5" />
      <span>{info?.status || t}</span>
      {info?.accuracy && (
        <span data-testid={`accuracy-string-${t}`} className="opacity-70 font-normal">· {info.accuracy}</span>
      )}
    </span>
  );
}

export function RegistryBadge({ registry, children, className = "" }) {
  const r = REGISTRY_STYLES[registry] || { bg: "bg-slate-800 text-slate-300 border-slate-700", short: registry };
  return (
    <span className={`inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-[11px] font-mono font-semibold ${r.bg} ${className}`}>
      {children || r.short}
    </span>
  );
}
